import React, { useMemo } from 'react';
import { isUndefined } from '../../../utils/isDefined';
import DataRow from '../../../partials/Datarow/DataRow';
import { withStyles } from '@material-ui/styles';

import styles from '../styles/changeSubscription';
import { translate } from '../../../i18n/I18nProvider';

const CancelMigration = ({
  migration = {},
  productsOptions = [],
  lang,
  classes
}) => {
  const customClasses = {
    root: classes.datarowRoot,
    label: classes.dataRowLabel,
    value: classes.datarowValue
  };

  const newSku = useMemo(() => {
    const founded = productsOptions.find(
      product => product.sku === migration.sku
    );

    if (isUndefined(founded)) {
      return migration.sku;
    }

    return (
      founded.translations?.sku?.[lang] ||
      founded.translations?.sku?.default ||
      migration.sku
    );
  }, [migration.sku, productsOptions, lang]);

  return (
    <div>
      <DataRow
        label={translate('SUBSCRIPTIONS.CURRENTLY_IN_MIGRATION')}
        value={newSku}
        customClasses={customClasses}
      />
      <DataRow
        label={translate('SUBSCRIPTIONS.CHANGE_DATE')}
        value={migration.changeDate}
        customClasses={customClasses}
      />
    </div>
  );
};

export default withStyles(styles)(CancelMigration);
